import { MatchKeysAndValues, QuerySelector } from "../../../@components/interfaces";
import { xget, xhttp } from "../Fetchv2";
import { PGSchema } from "../schemas/pg.schema.js";

export class AdminPages {
	getPages(where?: { [key in keyof PGSchema.pages]?: PGSchema.pages[key] | QuerySelector<PGSchema.pages[key]> }) {
		let queryJSON = JSON.stringify({ where: where });
		return xget<{ pages: PGSchema.pages[]; users: PGSchema.users[] }>(`/admin/pages`, { body: queryJSON });
	}

	getPage(id: PGSchema.pages["id"]) {
		return xget<{ page: PGSchema.pages; users: PGSchema.users[] }>(`/admin/pages/${id}`);
	}

	editPage(uid: string, body: { page?: MatchKeysAndValues<PGSchema.pages> | FormData; slave_pages?: { added: string[]; removed: string[] } }) {
		let prefix = ["psm", "u_", "created_at", "last_used", "updated_at"];
		if (body.page) {
			Object.keys(body.page).forEach(key => {
				if (prefix.some(p => key.startsWith(p))) {
					// @ts-ignore
					delete body.page[key];
				}
			});
		}
		return xhttp<{ page: PGSchema.pages }>(`/admin/pages/${uid}`, "PUT", body);
	}
}
